import { useEffect, useState } from 'react'

const DARK_MODE_QUERY = '(prefers-color-scheme: dark)'

const getIsDarkMode = (): boolean => window.matchMedia(DARK_MODE_QUERY).matches

const listeners = new Set<(isDarkMode: boolean) => void>()
let mql: MediaQueryList | undefined

const handleChange = (e: MediaQueryListEvent) => {
  listeners.forEach((listener) => listener(e.matches))
}

const subscribe = (listener: (isDarkMode: boolean) => void) => {
  if (!mql) {
    mql = window.matchMedia(DARK_MODE_QUERY)
    mql.addEventListener('change', handleChange)
  }
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
    if (listeners.size === 0 && mql) {
      mql.removeEventListener('change', handleChange)
      mql = undefined
    }
  }
}

export const useDarkMode = (): boolean => {
  const [darkMode, setDarkMode] = useState<boolean>(getIsDarkMode)

  useEffect(() => subscribe(setDarkMode), [])

  return darkMode
}
